import React, { useState, useEffect, useCallback, useRef } from "react";
import Timer from "./Timer";
import capitals from "../utils/capitals.json";
import { getNewCountry, getRandomCountry, countries } from "../utils/util";
import { Button, Row, Col, Form, Container } from "react-bootstrap";
import ScoreModal from "./ScoreModal";
import { ClockFill, StarFill, Trophy } from "react-bootstrap-icons";

export default function CapitalsGameEasy({
  easyGameInProgress,
  setEasyGameInProgress,
  easyHighScore,
  usedCountry,
  startingCountry,
}) {
  const [score, setScore] = useState(0);
  const scoreRef = useRef(score);
  scoreRef.current = score;
  const [country, setCountry] = useState(startingCountry);
  const [options, setOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const handleGameOver = useCallback(() => {
    const updateHighScore = async (score) => {
      try {
        if (score <= easyHighScore) return;
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/updateCapitalsGameHighScore`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              mode: "easy",
              score: score,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to update high score");
        }
      } catch (err) {
        console.error("Error updating high score:", err);
      }
    };
    setShowModal(true);

    updateHighScore(scoreRef.current);
  }, [easyHighScore]);

  useEffect(() => {
    if (usedCountry.size === 194) {
      setEasyGameInProgress(false);
      handleGameOver();
    }
    let newOptions = [capitals[country]];
    for (let i = 0; i < 3; i++) {
      let option;
      do {
        option = getRandomCountry(countries);
      } while (newOptions.includes(capitals[option]));
      Math.random() < 0.5
        ? newOptions.push(capitals[option])
        : newOptions.unshift(capitals[option]);
    }
    setOptions(newOptions);
  }, [country, handleGameOver, setEasyGameInProgress, usedCountry]);

  const handleOptionChange = (e) => {
    const currentOption = e.target.value;
    if (currentOption === capitals[country]) {
      setScore((prevScore) => prevScore + 4);
    } else {
      setScore((prevScore) => prevScore - 1);
    }
    setCountry(getNewCountry(usedCountry));
  };
  const skipHandler = (e) => {
    e.preventDefault();
    setCountry(getNewCountry(usedCountry));
  };
  return (
    <Container>
      <Container>
        <Row className="text-center justify-content-around align-items-center mb-4">
          <Col md={4}>
            <div>
              <ClockFill color="blue" size={24} className="mb-1" />
              <Timer
                gameInProgress={easyGameInProgress}
                handleGameOver={handleGameOver}
              />
            </div>
          </Col>

          <Col md={4}>
            <div>
              <StarFill color="orange" size={24} className="mb-1" />
              <h5>Score: {score}</h5>
            </div>
          </Col>

          <Col md={4}>
            <div>
              <Trophy color="gold" size={24} className="mb-1" />
              <h5>High Score: {easyHighScore}</h5>
            </div>
          </Col>
        </Row>
      </Container>
      {easyGameInProgress && (
        <Container>
          <Form>
            <Form.Group className="mb-3" controlId="country">
              <Form.Label className="fs-1 display-2">{country}</Form.Label>
              <Col md={4} sm={12}>
                <div className="d-grid gap-3">
                  {options.map((option, index) => (
                    <Button
                      key={index}
                      variant="light"
                      size="lg"
                      className="p-3 text-start border"
                      onClick={handleOptionChange}
                      value={option}
                    >
                      {option}
                    </Button>
                  ))}
                </div>
              </Col>
            </Form.Group>

            <Button variant="secondary" onClick={skipHandler}>
              Skip
            </Button>
          </Form>
        </Container>
      )}

      <ScoreModal 
        show={showModal} 
        handleClose={() => setShowModal(false)} 
        score={score} 
        highScore={easyHighScore} 
      />
    </Container>
  );
}
